import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Schedule } from '../../../../../domain/schedule.model';
import { IOfferAction } from '../../../store/ioffer.action';
import { IOfferState } from '../../../store/ioffer.state';

@Component({
    selector: 'app-iverification',
    templateUrl: './iverification.component.html',
    styleUrls: ['./iverification.component.scss']
})
export class IVerificationComponent {
    public pesel = '';
    wrongPesel: boolean = false;

    @Select(IOfferState.getWrongPesel) wrongPesel$: Observable<boolean>;

    constructor(private store: Store, private route: ActivatedRoute) {
    }

    confirm() {
        this.store.dispatch(new IOfferAction.GetToken(this.route.snapshot.params.token, this.pesel));
    }
}
